




























































import { ErrorCodes } from '@ringana/errors';
import Vue from 'vue';
import FetchError from '@/errors/fetch-error';
import CustomerHelper from '../../helpers/CustomerHelper';
import ProductListMixins from '../../mixins/ProductListMixins';
import CookieHelper from '../../helpers/CookieHelper';
import PriceMethods from '../../methods/PriceMethods';
import OldFormatHelper from '../../helpers/OldFormatHelper';
import DataLayerHelper from '../../helpers/DataLayerHelper';
import FormatHelper from '@/helpers/FormatHelper';
import { IProduct } from '@/common/interfaces/products.interface';
import ProductHelper from '@/helpers/ProductHelper';

interface ISingleProductComplementComponent {
  additionalUnitData: string;
  formatHelper: typeof OldFormatHelper;
  initialized: boolean;
  isPartner: boolean;
  loading: boolean;
}

export default Vue.extend({
  mixins: [ProductListMixins],
  data(): ISingleProductComplementComponent {
    return {
      additionalUnitData: ``,
      formatHelper: OldFormatHelper,
      initialized: false,
      isPartner: false,
      loading: false,
    };
  },
  props: {
    limitingActive: {
      default: false,
      type: Boolean,
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct,
    },
    shoppingAllowed: {
      default: true,
      type: Boolean,
    },
    t: {
      default: () => {},
      type: Object as () => unknown,
    },
  },
  async mounted(): Promise<void> {
    await this.setAdditionalUnit();
  },
  methods: {
    ...PriceMethods,
    async addItemToCart(matchcode: string): Promise<void> {
      this.loading = true;
      const cartId = CookieHelper.getLastUsedCartId();

      try {
        await this.$cartService.addItemToCart({ amount: 1, matchcode }, cartId);
      } catch (err) {
        if(!(err instanceof FetchError && err.errorCode === ErrorCodes.LIMITING_BOUNCER_ACTIVE)) {
          throw err;
        }
        // all good, hodor should be active now
      }

      const atcProducts = {
        id: this.productInfo.matchcode,
        name: this.productInfo.title,
        price: this.getMyPriceUnformatted(),
        quantity: 1,
      };
      DataLayerHelper.setProductInfoOnAddToCartToGtm(atcProducts);
      this.loading = false;
    },
    async checkPartnerStatus(): Promise<void> {
      this.isPartner = await CustomerHelper.getPartnerStatus();
    },
    async getPriceString(price: number | null): Promise<string> {
      if(!this.$currencyService.hasCurrencies()) {
        await this.$currencyService.fetchCurrencies();
      }
      const currencySymbol = this.$currencyService.getCurrencySymbol(this.productInfo.currency);
      return `${currencySymbol} ${FormatHelper.formatPrice(price)}`;
    },
    async setAdditionalUnit(): Promise<void> {
      const wpProductData = await this.$wpApiService.getExtendedSingleProductData(
        this.productInfo.link.split(`/`)[2],
        CookieHelper.getLanguage(),
        this.productInfo.image,
      );
      if(this.productInfo.basePrice.brutto && wpProductData.unitPriceData.amount !== null && wpProductData.unitPriceData.amount > 0 && wpProductData.unitPriceData.type !== null) {
        const { text, unitPriceType } = ProductHelper.formatAdditionalUnitPrice(this.productInfo, wpProductData.unitPriceData, this.isPartner);
        this.additionalUnitData = text.replaceAll(`{{unitPriceType}}`, this.$t(unitPriceType));
      }
    },
  },
});
